import React from 'react'
import './Watch.css'
import img7 from '../../assets/img7.jpg'
import { Navigate } from "react-router-dom";

function Watch() {
  return (
    <div>
          {/* <div className='watch_main'>
        <img src={img7} className='watch_img'></img>
              
    </div> */}
          <div className='watch_main'>
              <button class="button-87 " role="button" onClick={() => window.location.href = 'https://online.forms.app/hiphopcryptowatch/whitelist-application-form'}>Join Waitlist</button>
          </div>
    </div>
  )
}

export default Watch